<template>
  <div class="van-img flex-1 relative">
    <!-- 支持rem -->
    <!-- <van-image width="100%" :height="height" fit="contain" :src="images">
            <template slot='error'>暂无图片</template>
        </van-image> -->
    <div
      class="box-img"
      :style="{height:height+'px'}"
      @click="preview(0)"
    >
      <p
        v-if="!(images.length)"
        class="no-img"
      >
        暂无图片
      </p>
      <!-- v-preview="images" -->
      <template v-else>
        <img :src="images">
      </template>
    </div>
    <p
      v-if="!!imagesSummary"
      class="summary"
      @click="detailEvent"
    >
      {{ imagesSummary }}
    </p>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
    name: 'VanImg',
    components: {},
    props: {
        height: {
            type: Number,
            default: 200
        },
        imagesSummary: {
            type: String,
            default: ''
        },
        imgFlag: {
            type: String,
            default: ''
        },
        images: {
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    },
    methods: {
        preview(index) {
            if (!this.images.length) return
            ImagePreview({
                images: [this.images],
                showIndex: false
            })
        },
        detailEvent() {
            let obj = {
                imgUrl: this.images,
                imgName: this.imagesSummary,
                imgPageFlag: this.imgFlag
            }
            this.$emit('imgFlag', obj)
        }
    }
}
</script>

<style scoped lang='scss'>
.van-img {
  position: relative;
  .box-img {
    position: relative;
    width: 100%;
    .no-img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.28rem;
      white-space: nowrap;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .summary {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 0.6rem;
    line-height: 0.6rem;
    width: 100%;
    text-align: center;
    background: rgba(39, 97, 255, 0.7);
    font-size: 0.28rem;
  }
}
</style>
